import { useEffect } from "react";

import { controllerHub } from "../../../services/controllers/hub";

import { Agendamentos } from "./Agendamentos";
import { HeatMap } from "./HeatMap";
import { Header } from "./Header";
import { useQueryParam } from "use-query-params";


export function Agenda() {
  const CLHub = controllerHub()
  const [active,] = useQueryParam("date");

  useEffect(() => {
    CLHub.getDay(active)
  }, [active])



  return (
    <div className="w-full rounded-lg border-zinc-200/30 shadow-md border p-4 gap-2 flex flex-col sm:col-span-3 sm:row-[span_16_/_span_16] md:col-span-4 md:row-span-11 lg:col-span-6 lg:row-span-8 xl:col-span-6 xl:row-[span_16_/_span_16] bg-white">
      <Header />
      <div className="flex-1 w-full flex items-end flex-col gap-4 mt-2">
        <Agendamentos />
        <HeatMap />
      </div>
    </div>
  );
}
